import React, { useEffect, useState } from 'react';
import { CheckCircle2, CrownIcon } from 'lucide-react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila', 'Fernanda', 'Alejandro', 'Gabriela', 'José', 'Paola'];
const COUNTRIES = ['Buenos Aires 🇦🇷', 'Córdoba 🇦🇷', 'Rosario 🇦🇷', 'Mendoza 🇦🇷', 'Tucumán 🇦🇷', 'La Plata 🇦🇷', 'Mar del Plata 🇦🇷', 'Salta 🇦🇷', 'Santa Fe 🇦🇷', 'San Juan 🇦🇷', 'Neuquén 🇦🇷', 'Bahía Blanca 🇦🇷', 'Resistencia 🇦🇷', 'Posadas 🇦🇷', 'San Luis 🇦🇷'];
const PRODUCT = 'Pack 100 Citas';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: '',
    product: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentPurchase({
        name: randomName,
        country: randomCountry,
        product: PRODUCT
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const isCompleto = currentPurchase.product === 'Pack Completo';
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm rounded-lg shadow-2xl p-4 flex items-start gap-3 transition-all duration-300 ${isCompleto ? 'bg-gradient-to-br from-yellow-50 to-amber-50 border-2 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.3)]' : 'bg-white border border-gray-200'}`} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateX(0)' : 'translateX(-120%)',
    pointerEvents: isVisible ? 'auto' : 'none'
  }} data-id="element-201">
      <div className="mt-1 flex-shrink-0" data-id="element-202">
        {isCompleto ? <CrownIcon className="w-6 h-6 text-yellow-500" data-id="element-203" /> : <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-204" />}
      </div>
      <div data-id="element-205">
        <p className="text-sm text-gray-800" data-id="element-206">
          <span className="font-bold" data-id="element-207">{currentPurchase.name}</span> de{' '}
          <span className="font-bold" data-id="element-208">{currentPurchase.country}</span> acaba de
          comprar el
        </p>
        <p className={`text-sm font-bold mt-1 ${isCompleto ? 'text-yellow-600' : 'text-blue-600'}`} data-id="element-209">
          {isCompleto && '🏆 '}
          {currentPurchase.product}!
        </p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-210">Hace unos segundos</p>
      </div>
    </div>;
}